import MemberManagement from "@/views/MemberView/MemberManagement.vue";
import ApprovalRequest from "@/views/MemberView/ApprovalRequest.vue";
import AdminManagement from "@/views/MemberView/AdminManagement.vue";

import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

/**
 * 회원 관리 페이지에 대한 routes
 */

const memberMenu = {
  path: "/members",
  component: DashboardLayout,
  redirect: "/members/management",
  name: "Members",
  children: [
    {
      path: "management",
      name: "member-management",
      components: { default: MemberManagement },
      meta: {
        requiresAuth: true,
        requiredRoles: ["member", "master"],
        title: "topnav.member_list",
      },
    },
    {
      path: "approval-reqeust",
      name: "member-approval-reqeust",
      components: {
        default: ApprovalRequest,
      },
      meta: {
        requiresAuth: true,
        requiredRoles: ["member", "master"],
        title: "topnav.member_approval_request",
      },
    },
    {
      path: "admin-management",
      name: "admin-management",
      components: {
        default: AdminManagement,
      },
      meta: {
        requiresAuth: true,
        requiredRoles: ["master"],
        title: "topnav.admin_management",
      },
    },
  ],
};

export default memberMenu;
